/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateActivityDto
 */
export interface UpdateActivityDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateActivityDto
     */
    note?: string;
    /**
     * 
     * @type {Date}
     * @memberof UpdateActivityDto
     */
    dateDeadline?: Date;
    /**
     * 
     * @type {string}
     * @memberof UpdateActivityDto
     */
    summary?: string;
}

/**
 * Check if a given object implements the UpdateActivityDto interface.
 */
export function instanceOfUpdateActivityDto(value: object): value is UpdateActivityDto {
    return true;
}

export function UpdateActivityDtoFromJSON(json: any): UpdateActivityDto {
    return UpdateActivityDtoFromJSONTyped(json, false);
}

export function UpdateActivityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateActivityDto {
    if (json == null) {
        return json;
    }
    return {
        
        'note': json['note'] == null ? undefined : json['note'],
        'dateDeadline': json['date_deadline'] == null ? undefined : (new Date(json['date_deadline'])),
        'summary': json['summary'] == null ? undefined : json['summary'],
    };
}

export function UpdateActivityDtoToJSON(json: any): UpdateActivityDto {
    return UpdateActivityDtoToJSONTyped(json, false);
}

export function UpdateActivityDtoToJSONTyped(value?: UpdateActivityDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'note': value['note'],
        'date_deadline': value['dateDeadline'] == null ? value['dateDeadline'] : value['dateDeadline'].toISOString(),
        'summary': value['summary'],
    };
}

